import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useEffect, useState } from "react";
import { ScrollView, Text, TouchableOpacity, View, Picker } from "react-native";
import HeaderTabs from "../../components/HeaderTabs";
import NumberInput from "../../components/NumberInput";
import activesService from "../../services/activesService";
import balanceService from "../../services/balanceService";
import { maxDecimals } from "../../utils/formatNumber";
import styles from "./styles";
import { FormattedMessage } from "react-intl";
import { If, Then, Else } from "react-if";
import GoBackButton from "../../components/GoBackButton";

const Transfer = ({ navigation }) => {
  const defaultItem = {
    label: "GPX",
    value: -1,
  };

  const [items, setItems] = useState([defaultItem]);
  const [balance, setBalance] = useState("");

  const [amount, setAmount] = useState(0);
  const [selectedActive, setSelectedActive] = useState(null);
  const [selectedActiveObj, setSelectedActiveObj] = useState(null);

  const [price, setPrice] = useState(0.0);
  const [authToken, setAuthToken] = useState(null);

  const [actives, setActives] = useState([]);
  const [open, setOpen] = useState(false);

  const [minTransfer, setMinTransfer] = useState(1);

  const [decimals, setDecimals] = useState(0);

  const [amountToken, setAmountToken] = useState(0);

  useEffect(() => {
    let itemsAr = [defaultItem];
    actives.map((el) => {
      itemsAr.push({
        label: el.name_token,
        value: el.id,
      });
    });
    setItems(itemsAr);
  }, [actives]);

  useEffect(() => {
    loadTokenAndRequest();
  }, []);

  useEffect(() => {
    if (parseInt(selectedActive + "") === -1) {
      setSelectedActiveObj({
        id: -1,
        name_token: "GPX",
        single_value: 1,
        amount_token: "-",
      });
      loadBalanceGPX();
    } else {
      actives.map((el) => {
        if (el.id + "" === selectedActive + "") {
          setSelectedActiveObj(el);
          if (el.single_value) {
            setPrice(parseFloat(el.single_value));
          }
          if (el.name_token) {
            if (["BTC", "ETH", "ADA"].indexOf(el.name_token) !== -1)
              setDecimals(8);
            if (
              !el.cryptoactive &&
              ["BTC", "ETH", "ADA"].indexOf(el.name_token) === -1
            ) {
              loadAmountToken();
            } else {
              setAmountToken(0);
            }
          }
        }
      });
      loadBalance();
    }
  }, [selectedActive]);

  useEffect(() => {
    calcMinTransfer();
  }, [selectedActiveObj]);

  useEffect(() => {
    if (authToken) {
      loadActivesWithBalance();
    }
  }, [authToken]);

  const loadAmountToken = async () => {
    if (authToken) {
      activesService.getById(authToken, selectedActive).then((response) => {
        if (response.data?.count) {
          setAmountToken(response.data?.count);
        }
      });
    }
  };

  const loadTokenAndRequest = async () => {
    const authTokenStorage = await AsyncStorage.getItem("JWT_TOKEN");
    setAuthToken(authTokenStorage);
  };

  const loadActivesWithBalance = async () => {
    try {
      const authToken = await AsyncStorage.getItem("JWT_TOKEN");
      const clientCountry = await AsyncStorage.getItem("client_country");
      const response = await activesService.getActivesWhereUserHasBalance(
        authToken
      );

      if (response.data.length > 0) {
        const filteredActives = response.data.filter((active) => {
          return (
            active.adoption !== true &&
            !(active.category_name === "I-REC" && clientCountry !== "brasil") &&
            !active.category_name.toLowerCase().includes("selo")
          );
        });

        setActives(filteredActives);
      }
    } catch (error) {
      console.error("Error fetching actives:", error);
    }
  };

  const loadBalance = () => {
    if (authToken) {
      balanceService
        .getBalanceOfToken(authToken, selectedActive)
        .then((response) => {
          setBalance(response?.data?.saldo + "");
        })
        .catch((error) => {});
    }
  };

  const loadBalanceGPX = () => {
    if (authToken) {
      balanceService
        .getBalanceOfGpx(authToken)
        .then((res) => {
          if (res.data.balance[0]?.available_balance) {
            setBalance(res.data.balance[0].available_balance);
          } else {
            setBalance(res.data.balance[0].saldo);
          }
        })
        .catch((error) => {});
    }
  };

  const calcMinTransfer = () => {
    if (selectedActiveObj) {
      if (selectedActiveObj.name_token === "BTC") {
        setMinTransfer(0.0008);
      } else if (selectedActiveObj.name_token === "ADA") {
        setMinTransfer(10);
      } else if (selectedActiveObj.name_token === "ETH") {
        setMinTransfer(0.016);
      } else if (selectedActiveObj.name_token === "GPX") {
        setMinTransfer(10);
        setDecimals(2);
      } else {
        setAmount(Math.round);
        setMinTransfer(1);
        setDecimals(0);
      }
    }
  };

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="transfer.tituloTransferir" />}
        subtitle={<FormattedMessage id="transfer.desejoTransferir" />}
      />
      <ScrollView>
        <View style={styles.content}>
          <FormattedMessage id="transfer.selecioneAtivo">
            {(optionAtivo) => (
              <View style={styles.contentSelect}>
                <Picker
                  selectedValue={selectedActive}
                  onValueChange={(itemValue) => setSelectedActive(itemValue)}
                  style={styles.pickerAtivos}
                >
                  <Picker.Item label={optionAtivo} value="0" />
                  {items.map((el, index) => (
                    <Picker.Item
                      key={index}
                      label={el.label}
                      value={el.value}
                    />
                  ))}
                </Picker>
              </View>
            )}
          </FormattedMessage>
          <If condition={selectedActive}>
            <Then>
              <>
                <View style={styles.containerMeuSaldo}>
                  <Text style={styles.txtMeuSaldo}>
                    <FormattedMessage id="transfer.meuSaldo" />
                    {"\n"}
                    <Text style={styles.txtSaldoReal}>
                      <If condition={selectedActiveObj?.cryptoactive}>
                        <Then>{maxDecimals(balance, 8)}</Then>
                        <Else>{balance}</Else>
                      </If>{" "}
                      {selectedActiveObj && selectedActiveObj.name_token}
                    </Text>
                  </Text>
                </View>
                <View style={styles.containerPreco}>
                  <Text
                    style={{
                      ...styles.textAmount,
                      flex: 0.5,
                      textTransform: "uppercase",
                    }}
                  >
                    <FormattedMessage id="transfer.txtPreco" />
                  </Text>
                  <Text
                    style={{
                      ...styles.textAmount,
                      flex: 0.5,
                      textAlign: "right",
                    }}
                  >
                    {selectedActiveObj && selectedActiveObj.single_value}{" "}
                    <FormattedMessage id="transfer.gpx" />
                  </Text>
                </View>
                <View style={{ textAlign: "right", color: "#999999" }}>
                  <Text style={{ textAlign: "right", color: "#999999" }}>
                    {selectedActiveObj && selectedActiveObj.single_value}
                    <FormattedMessage id="transfer.brl" />
                  </Text>
                </View>

                <View style={styles.contentPurchase}>
                  <Text style={styles.titlePurchase}>
                    <FormattedMessage id="transfer.quantasUnidades" />
                  </Text>
                  <View style={styles.contentPurchaseAmount}>
                    <NumberInput
                      minValue={0}
                      value={amount}
                      maxDecimalsParam={decimals}
                      onChange={(value) => setAmount(value)}
                    />
                  </View>
                </View>
              </>
            </Then>
            <Else>
              <>
                <View style={styles.containerMsgAntesCont}>
                  <Text style={{ textAlign: "center" }}>
                    <FormattedMessage id="transfer.antesContinuar" />
                  </Text>
                </View>
              </>
            </Else>
          </If>
          <View style={styles.contentBtn}>
            <If condition={selectedActive}>
              <Then>
                {amount && parseFloat(amount + "") >= minTransfer ? (
                  parseFloat(amount + "") > parseFloat(balance) ? (
                    <TouchableOpacity
                      onPress={() => navigation.navigate("DepositMethod")}
                      style={styles.btn}
                    >
                      <Text style={styles.textBtn}>
                        <FormattedMessage id="transfer.saldoInsuficiente" />
                      </Text>
                    </TouchableOpacity>
                  ) : (
                    <TouchableOpacity
                      style={styles.btn}
                      disabled={amount <= 0 ? true : false}
                      onPress={() =>
                        navigation.navigate({
                          name: "TransferFindUser",
                          params: { token: selectedActive, qtd: amount },
                        })
                      }
                    >
                      <Text style={styles.textBtn}>
                        {" "}
                        <FormattedMessage id="transfer.continuar" />
                      </Text>
                    </TouchableOpacity>
                  )
                ) : (
                  <TouchableOpacity
                    disabled={true}
                    style={[styles.btn, { minHeight: 50 }]}
                  >
                    <Text style={styles.textBtn}>
                      <FormattedMessage id="transfer.minimoDe" /> {minTransfer}{" "}
                      {selectedActiveObj?.name_token}
                    </Text>
                  </TouchableOpacity>
                )}
              </Then>
              <Else>
                <TouchableOpacity disabled={true} style={styles.btn}>
                  <Text style={styles.textBtn}>
                    <FormattedMessage id="transfer.selecioneAtivo" />
                  </Text>
                </TouchableOpacity>
              </Else>
            </If>
          </View>
          <GoBackButton />
        </View>
      </ScrollView>
    </>
  );
};

export default Transfer;
